import { createAction, props } from "@ngrx/store";
import { Area } from "../../models/area";

/*CRUD CATALOG AREA*/
export const getAllAreasCatalogAct = createAction('getAllAreasCatalogEffect');
export const loadAllAreasCatalogAct = createAction('loadAllAreasCatalogEffect', props<{ areas: Area[] }>());

export const findAreaAct = createAction('findAreaEffect', props <{ id: number }>());
export const loadAreaByIdAct = createAction('loadAreaByIdEffect', props<{ area: Area }>());

export const saveAreaAct = createAction('saveAreaEffect', props<{ areaNew: Area }>());
export const saveSuccessAreaAct = createAction('saveSuccessAreaEffect', props<{ areaNew: Area }>());

export const updateAreaAct = createAction('updateAreaEffect', props<{ areaUpdated: Area }>());
export const updateSuccessAreaAct = createAction('updateSuccessAreaEffect', props<{ areaUpdated: Area }>());
/*CRUD CATALOG AREA END*/
export const setViolationsAreaAct = createAction('setViolationsAreaffect', props<{ areaForm: Area, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );